export const TAG_COLORS = [
  '#FF5733',
  '#33FF57',
  '#3357FF',
  '#FF33A1',
  '#A133FF',
  '#33FFA1',
  '#FF7F50',
  '#6A5ACD',
  '#2E8B57',
  '#DC143C',
  '#00CED1',
  '#FFD700',
  '#FF69B4',
  '#8A2BE2',
  '#7FFF00',
];